import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { path: '/', label: 'Daily' },
  { path: '/weekly', label: 'Weekly' },
  { path: '/dashboard', label: 'Dashboard' },
];

const PAGE_TITLES = {
  '/': 'Daily Check-In',
  '/weekly': 'Weekly Reflection',
  '/dashboard': 'Team Dashboard',
};

export default function Layout({ children }) {
  const location = useLocation();

  useEffect(() => {
    const segment = PAGE_TITLES[location.pathname];
    document.title = segment ? `Burnoff - ${segment}` : 'Burnoff';
  }, [location.pathname]);

  return (
    <div className="min-h-screen min-w-0 bg-background overflow-x-hidden">
      <header className="border-b border-stone-200/70 bg-card/80 backdrop-blur-sm">
        <div className="max-w-3xl mx-auto px-4 py-5 sm:px-6 sm:py-6 md:px-8">
          <h1 className="text-lg font-semibold tracking-tight text-stone-800 sm:text-xl">
            Burnoff
          </h1>
          <p className="mt-1 text-xs text-stone-500 leading-relaxed sm:text-sm">
            Teams become emotionally aware before silence becomes burnout.
          </p>

          <nav className="mt-6 mb-2 flex justify-center sm:mt-8" aria-label="Reflection mode">
            <div
              className="inline-flex min-w-0 max-w-full flex-shrink rounded-full bg-stone-100/80 p-1.5"
              role="tablist"
            >
              {NAV_ITEMS.map(({ path, label }) => {
                const isActive = location.pathname === path;
                return (
                  <Link
                    key={path}
                    to={path}
                    role="tab"
                    aria-selected={isActive}
                    className={`
                      relative rounded-full px-3 py-2 text-sm font-medium sm:px-5 sm:py-2.5
                      transition-all duration-200 ease-out
                      focus:outline-none focus-visible:ring-2 focus-visible:ring-stone-400 focus-visible:ring-offset-2
                      ${isActive
                        ? 'bg-white text-stone-800 shadow-soft scale-[1.02]'
                        : 'text-stone-500 hover:text-stone-600'
                      }
                    `}
                  >
                    {label}
                  </Link>
                );
              })}
            </div>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto min-w-0 px-4 py-8 sm:px-6 sm:py-10 md:px-8 md:py-12">
        {children}
      </main>

      <footer className="mt-10 pb-8 text-center">
        <p className="text-xs text-stone-400">
          Burnoff v0.0.1 ·{' '}
          <a
            href="https://burnoff.super.site/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-stone-500 hover:text-stone-600 underline transition-colors duration-200"
          >
            🧠 About the idea
          </a>
        </p>
      </footer>
    </div>
  );
}
